<template>
    <div>
        <div class="top_texts">
            <h3>Wat zijn de gegevens voor op de overeenkomst?</h3>
        </div>
        <div class="row_container">
            <div style="width: 100%;">
                <div class="form-group">
                    <h3>Contractant</h3>
                </div>
            </div>
        </div>
        <div class="row_container">
            <div style="width: 50%;">
                <div class="form-group">
                    <label for="coc_number">Kvk-nummer</label>
                    <input id="coc_number" type="text" v-model="contract.coc_number"
                           :class="{error: $v.contract.coc_number.$error}">
                </div>
            </div>
        </div>
        <div class="row_container">
            <div style="width: 50%;">
                <div class="form-group">
                    <label for="company_name">Bedrijfsnaam</label>
                    <input id="company_name" type="text" v-model="contract.company_name"
                           :class="{error: $v.contract.company_name.$error}">
                </div>
            </div>
            <div style="width: 50%;">
                <div class="form-group">
                    <label for="authorized_signatory">Tekenbevoegde</label>
                    <input id="authorized_signatory" type="text"
                           v-model="contract.authorized_signatory"
                           :class="{error: $v.contract.authorized_signatory.$error}">
                </div>
            </div>
        </div>
        <div class="row_container">
            <div style="width: 50%;">
                <div class="form-group">
                    <label for="zipcode">Postcode</label>
                    <input id="zipcode" type="text" v-model="contract.zipcode"
                           :class="{error: $v.contract.zipcode.$error}">
                </div>
            </div>
            <div style="width: 35%;">
                <div class="form-group">
                    <label for="house_number">Huisnummer</label>
                    <input id="house_number" type="text"
                           v-model="contract.house_number"
                           :class="{error: $v.contract.house_number.$error}">
                </div>
            </div>
            <div style="width: 15%;">
                <div class="form-group">
                    <label for="house_number_addition">Toevoeging</label>
                    <input id="house_number_addition" type="text"
                           v-model="contract.house_number_addition">
                </div>
            </div>
        </div>
        <div class="row_container">
            <div style="width: 50%;">
                <div class="form-group">
                    <label for="street_name">Straatnaam</label>
                    <input id="street_name" type="text" v-model="contract.street_name"
                           :class="{error: $v.contract.street_name.$error}">
                </div>
            </div>
            <div style="width: 50%;">
                <div class="form-group">
                    <label for="place">Plaats</label>
                    <input id="place" type="text"
                           v-model="contract.place"
                           :class="{error: $v.contract.place.$error}">
                </div>
            </div>
        </div>
        <div class="row_container">
            <div style="width: 50%;">
                <div class="form-group">
                    <label for="authorized_signatory_email">Emailadres contractant</label>
                    <input id="authorized_signatory_email" type="text"
                           v-model="contract.authorized_signatory_email"
                           :class="{error: $v.contract.authorized_signatory_email.$error}">
                </div>
            </div>
            <div style="width: 50%;">
                <div class="form-group">
                    <label for="authorized_signatory_phone_number">Mobiel telefoonnummer
                        contractant</label>
                    <input id="authorized_signatory_phone_number" type="text"
                           v-model="contract.authorized_signatory_phone_number"
                           :class="{error: $v.contract.authorized_signatory_phone_number.$error}">
                </div>
            </div>
        </div>
        <div class="row_container">
            <div style="width: 100%;">
                <div class="form-group">
                    <h3>Facturatie</h3>
                </div>
            </div>
        </div>
        <div class="row_container">
            <div style="width: 50%;">
                <div class="form-group">
                    <label for="invoice_email">Emailadres facturatie</label>
                    <input id="invoice_email" type="text"
                           v-model="contract.invoice_email"
                           :class="{error: $v.contract.invoice_email.$error}">
                </div>
            </div>
            <div style="width: 50%;" v-if="!contract || !contract.hide_iban_field">
                <div class="form-group">
                    <label for="iban_number">IBAN voor automatische incasso</label>
                    <input id="iban_number" type="text"
                           v-model="contract.iban_number"
                           :class="{error: $v.contract.iban_number.$error}">
                </div>
            </div>
        </div>
        <div class="row_container">
            <div style="width: 100%;">
                <div class="form-group">
                    <h3>Contactgegevens</h3>
                </div>
            </div>
        </div>
        <div class="row_container">
            <div style="width: 50%;">
                <div class="form-group">
                    <label for="email">Emailadres contactpersoon</label>
                    <input id="email" type="text"
                           v-model="contract.email"
                           :class="{error: $v.contract.email.$error}">
                </div>
            </div>
            <div style="width: 50%;">
                <div class="form-group">
                    <label for="phone_number">Telefoonnummer contractpersoon</label>
                    <input id="phone_number" type="text"
                           v-model="contract.phone_number"
                           :class="{error: $v.contract.phone_number.$error}">
                </div>
            </div>
        </div>
        <div style="margin-top: 15px; margin-bottom: 100px;">
            <button class="btn btn-default pull-left" @click="$emit('prev_step')"
                    :class="{'is-disabled': working}">
                Vorige stap
            </button>
            <button class="btn btn-primary pull-right" @click="next_step"
                    :class="{'is-disabled': working}">
                Volgende stap
                <span v-if="working">
                    <font-awesome-icon :icon="['fal', 'spinner']" spin></font-awesome-icon>
                </span>
            </button>
        </div>
    </div>
</template>

<script>
import {
    email,
    minLength,
    numeric,
    required,
} from 'vuelidate/lib/validators';

function mod97(string) {
    let checksum = string.slice(0, 2);
    for (let offset = 2; offset < string.length; offset += 7) {
        const fragment = String(checksum) + string.substring(offset, offset + 7);
        checksum = parseInt(fragment, 10) % 97;
    }
    return checksum;
}

const iban_validator = (value, vm) => {
    // If iban field is hidden and there is no value, its valid.
    // Else if there is no value, its required to have some value.
    // Else check if iban is a valid iban.

    if (vm.hide_iban_field && !value) {
        return true;
    }

    if (!value) {
        return false;
    }

    const CODE_LENGTHS = {
        AD: 24,
        AE: 23,
        AT: 20,
        AZ: 28,
        BA: 20,
        BE: 16,
        BG: 22,
        BH: 22,
        BR: 29,
        CH: 21,
        CR: 21,
        CY: 28,
        CZ: 24,
        DE: 22,
        DK: 18,
        DO: 28,
        EE: 20,
        ES: 24,
        FI: 18,
        FO: 18,
        FR: 27,
        GB: 22,
        GI: 23,
        GL: 18,
        GR: 27,
        GT: 28,
        HR: 21,
        HU: 28,
        IE: 22,
        IL: 23,
        IS: 26,
        IT: 27,
        JO: 30,
        KW: 30,
        KZ: 20,
        LB: 28,
        LI: 21,
        LT: 20,
        LU: 20,
        LV: 21,
        MC: 27,
        MD: 24,
        ME: 22,
        MK: 19,
        MR: 27,
        MT: 31,
        MU: 30,
        NL: 18,
        NO: 15,
        PK: 24,
        PL: 28,
        PS: 29,
        PT: 25,
        QA: 29,
        RO: 24,
        RS: 22,
        SA: 24,
        SE: 24,
        SI: 19,
        SK: 24,
        SM: 27,
        TN: 24,
        TR: 26,
    };

    // keep only alphanumeric characters
    const iban = String(value).toUpperCase().replace(/[^A-Z0-9]/g, '');
    // match and capture (1) the country code, (2) the check digits, and (3) the rest
    const code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);

    // check syntax and length
    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
        return false;
    }
    // rearrange country code and check digits, and convert chars to ints
    const digits = (code[3] + code[1] + code[2]).replace(
        /[A-Z]/g,
        (letter) => letter.charCodeAt(0) - 55,
    );

    return mod97(digits) === 1;
};

export default {
    props: {
        contract: {},
        working: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            step_ready: false,

            getting_coc_info_bounce: this.$Microbounce(250),
            getting_coc_info: null,

            zip_request_bounce: this.$Microbounce(250),
            zip_request: null,

            update_house_number_request_bounce: this.$Microbounce(250),
            update_house_number_request: null,
        };
    },
    validations: {
        contract: {
            coc_number: {required},
            company_name: {required},
            authorized_signatory: {required},
            zipcode: {required},
            house_number: {required},
            street_name: {required},
            place: {required},
            authorized_signatory_email: {required, email},
            authorized_signatory_phone_number: {required, minLength: minLength(10), numeric},
            invoice_email: {required, email},
            iban_number: {iban_validator},
            email: {required, email},
            phone_number: {required, minLength: minLength(10), numeric},
        },
    },
    watch: {
        'contract.zipcode'(value) {
            const self = this;

            self.contract.zip_code = self.$fix_zip_code(value);
            self.zip_request_bounce(self.get_zipcode_data);
        },
        'contract.house_number'() {
            const self = this;
            self.zip_request_bounce(self.get_zipcode_data);
            self.update_house_number_request_bounce(self.update_house_number);
        },
        'contract.house_number_addition'() {
            const self = this;
            self.zip_request_bounce(self.get_zipcode_data);
        },
        'contract.coc_number'() {
            const self = this;
            self.getting_coc_info_bounce(self.get_coc_info);
        },
        'contract.iban_number'() {
            const self = this;
            if (self.contract.iban_number) {
                self.contract.iban_number = self.contract.iban_number.toUpperCase();
            }
        },
        'contract.authorized_signatory_email'(value) {
            const self = this;
            self.contract.email = value;
            self.contract.invoice_email = value;
        },
        'contract.authorized_signatory_phone_number'(value) {
            const self = this;
            self.contract.phone_number = value;
        },
    },
    methods: {
        next_step() {
            const self = this;

            self.$v.$reset();
            self.$v.$touch();

            if (self.$v.$invalid) {
                return;
            }

            self.step_ready = false;
            self.$emit('next_step');
        },
        get_coc_info() {
            const self = this;

            if (!self.step_ready) {
                return;
            }

            if (!self.contract.coc_number) {
                return;
            }

            if (self.getting_coc_info) {
                self.getting_coc_info.abort();
            }

            self.getting_coc_info = self.$rest(
                '/api/openkvk.get_kvk_info',
                {
                    body: {
                        coc_number: self.contract.coc_number.toString(),
                    },
                },
            ).then((response) => {
                self.getting_coc_info = null;

                if ('company_name' in response && !self.contract.company_name) {
                    self.contract.company_name = response.company_name;
                }

                if ('house_number' in response && !self.contract.house_number) {
                    self.contract.house_number = String(response.house_number);
                }

                if ('house_number_addition' in response && !self.contract.house_number_addition) {
                    self.contract.house_number_addition = response.house_number_addition;
                }

                if ('zipcode' in response && !self.contract.zipcode) {
                    self.contract.zipcode = response.zipcode;
                }

                if ('place' in response && !self.contract.place) {
                    self.contract.place = response.place;
                }

                if ('street' in response && !self.contract.street_name) {
                    self.contract.street_name = response.street;
                }
            });
        },
        get_zipcode_data() {
            const self = this;

            if (!self.step_ready) {
                return;
            }

            const zipcode = self.contract.zipcode || '';
            const house_number = self.contract.house_number || '';
            const house_number_addition = self.contract.house_number_addition || '';

            if (!zipcode || !house_number) {
                return;
            }

            if (self.zip_request) {
                self.zip_request.abort();
            }

            self.zip_request = self.$rest(
                '/api/zipcode.get_zipcode_data',
                {
                    body: {
                        zipcode: zipcode.toString(),
                        house_number: house_number.toString(),
                        house_number_addition: house_number_addition.toString() || '',
                    },
                },
            ).then((response) => {
                self.zip_request = null;

                if (!response.data) {
                    return;
                }

                if ('zipcode' in response.data) {
                    self.contract.zipcode = response.data.zipcode;
                }

                if ('city' in response.data) {
                    self.contract.place = response.data.city;
                }

                if ('street' in response.data) {
                    self.contract.street_name = response.data.street;
                }
            });
        },
        update_house_number() {
            const self = this;

            if (!self.step_ready) {
                return;
            }

            if (self.fetching_data) {
                return;
            }

            if (!self.contract.house_number) {
                return;
            }

            if (self.update_house_number_request) {
                self.update_house_number_request.abort();
            }

            self.update_house_number_request = self.$rest(
                '/api/zipcode.process_house_number',
                {
                    body: {
                        house_number: self.contract.house_number.toString(),
                    },
                },
            ).then((response) => {
                self.update_house_number_request = null;
                if ('addition' in response && self.contract.house_number_addition === '') {
                    self.contract.house_number = String(response.house_number);
                    self.contract.house_number_addition = response.addition;
                }
            });
        },
    },
    mounted() {
        const self = this;

        self.$nextTick(() => {
            setTimeout(() => {
                self.step_ready = true;
            }, 500);
        });
    },
};
</script>
